import PropTypes from "prop-types"
import { linkPropTypes, mediaPropTypes } from "../../../utils/types"
import Image from "next/image"
import CustomLink from "../custom-link"
import circleLogoUrl from "../../logos/circle-logo.svg?url"
//import CountrySelect from "../country-select/index-old"
import Input from "../input"
import Button from "../store-button"
import { BsFacebook, BsInstagram } from "react-icons/bs"
import { useState, useRef } from "react"

const Footer = ({ footer, locale }) => {

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const inputRef = useRef(null);

  // Prevent errors if no metadata was set
  if (!footer) {
    return null
  }

  async function submitEmailAddress(e) {
    //console.log(`submitting email address ${email}`)
    e.preventDefault();

    // this is where your mailchimp request is made

    const res = await fetch('/api/subscribe-user', {
      body: JSON.stringify({
        email: inputRef.current.value,
      }),

      headers: {
        'Content-Type': 'application/json',
      },

      method: 'POST',
    });

    //console.log(res);
  }

  return (
    <footer className="mt-16 bg-sunrise">

      <div className="container py-12 sm:py-16">

        {/* <div>
          {footer.logo && (
            <NextImage width="120" height="33" media={footer.logo}/>
          )}
        </div> */}
        <nav className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <img
            className="mx-auto block sm:hidden"
            src="https://res.cloudinary.com/helpfulcrowd/image/upload/image/stores/8XS9k1/badges/gGCEne/icon.png"
            width="272"
          ></img>

          {/* Newsletter */}
          <div key={"column-email"} className="lg:col-span-5">
            <div className="rounded-3xl border border-white/15 bg-white/10 p-6 shadow-sm backdrop-blur sm:p-8">


              <form onSubmit={submitEmailAddress}>
                {/* Your Email Address</label> */}
                <label htmlFor="list_email">
                  <p className="text-balance text-lg font-extrabold tracking-tight text-white sm:text-xl">

                    {"Join our mailing list and get access to exclusive discounts"}
                  </p>
                </label>
                <p className="mt-2 text-sm text-white/80">
                  Occasional drops. New flavors. Subscriber-only offers.
                </p>

                <div className="mt-5 flex flex-col gap-3">
                  <Input
                    className="block h-12 w-full rounded-full border border-white/20 bg-white/90 px-5 text-sm text-[#3f2415] shadow-sm placeholder:text-[#603026]/60 focus:outline-none focus:ring-2 focus:ring-white/40"
                    type="email"
                    name="list_email"
                    id="list_email"
                    autoComplete="email"
                    //autoCapitalize="off"
                    //autoCorrect="off"
                    //label="Email"
                    ref={inputRef}
                    required
                    placeholder="example@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Button variant='primary' onClick={submitEmailAddress} className="h-12 rounded-full px-6 font-extrabold shadow-sm">
                    Subscribe
                  </Button>
                </div>
              </form>
            </div>
          </div>

          {/* Link columns */}
          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              {footer.columns.map((footerColumn) => (
                <div
                  key={footerColumn.id}
                  className=""
                >
                  <p className="text-sm font-extrabold tracking-wide text-white/90">
                    {footerColumn.title}
                  </p>
                  <ul className="mt-3 space-y-2">
                    {footerColumn.links.map((link) => (
                      <li key={link.id}
                        className="text-white/85 hover:text-white">
                        <CustomLink link={link}>
                          <span className="text-sm font-semibold transition hover:underline underline-offset-4">
                            {link.text}
                          </span>
                        </CustomLink>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Social */}
            <div key={"logo_links"} className="mt-10">
              <p className="text-sm font-extrabold tracking-wide text-white/90">
                {"Follow Us"}
              </p>
              <ul className="mt-4 flex list-none flex-row items-center gap-3">
                {/* <ul className="mt-2 list-none justify-between items-baseline hidden"> */}
                <li key="facebook-link">
                  <CustomLink link={{ id: 'facebook_link', url: 'https://facebook.com/brownedandtoasted', text: 'Find us on Facebook', newTab: true }}>
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white shadow-sm ring-1 ring-white/15 transition hover:bg-white/20">
                      <BsFacebook />
                    </span>
                  </CustomLink>
                </li>
                <li key="instagram-link">
                  <CustomLink link={{ id: 'instagram_link', url: 'https://instagram.com/brownedandtoasted', text: 'Follow us on Instagram', newTab: true }}>
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white shadow-sm ring-1 ring-white/15 transition hover:bg-white/20">
                      <BsInstagram />
                    </span>
                  </CustomLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/15">
        <div className="container flex flex-col gap-6 py-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2 text-sm text-white/85">
            <div>{footer.smalltext}</div>
            <div className="text-white/70">{'Copyright 2025 Browned and Toasted LLC'}</div>
          </div>

          <div className="flex items-center justify-between gap-6 sm:justify-end">
            <Image className="grayscale invert mix-blend-screen"
              width="65"
              src={circleLogoUrl}
              alt='Browned & Toasted 2025'
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" />
            <div className="xsmall:justify-end"></div>
            {/* <CountrySelect locale={locale}/> */}
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  footer: PropTypes.shape({
    logo: mediaPropTypes.isRequired,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        title: PropTypes.string.isRequired,
        links: PropTypes.arrayOf(linkPropTypes),
      })
    ),
    smalltext: PropTypes.string.isRequired,
  }),
}

export default Footer